import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import { ErrorWord, yapNumberWhen, yapStringWhen, yupNumberString } from '../common';
/*--------------
  指定預金口座情報
  --------------*/
export enum DEPOSIT_TYPE {
  NORMAL = 1,
  SAVING,
}

export const getDepositType = (type: number | null) => {
  switch (type) {
    case DEPOSIT_TYPE.NORMAL:
      return true;
    case DEPOSIT_TYPE.SAVING:
      return false;
    default:
      return undefined;
  }
};

//入力値の型
export type DepositAccountType = {
  // 銀行コード
  bankCode: string;
  // 金融機関名
  bankName: string; //（これはリクエストに不要）
  // 店番号
  branchCode: string;
  // 支店名
  branchName: string; //（これはリクエストに不要）
  // 銀行口座番号
  accountNumber: string;
  // 預金種目
  depositForm: number;
};
//Formik用の型
export type DepositAccountFormikType = FormikProps<DepositAccountType>;

//Formikに渡す初期値
//登録情報画面用に金融機関名と支店名を渡せるようにしている
export const depositAccountInfoInitialValues = (
  param: DepositAccountType,
  bankName?: string | null,
  branchName?: string | null,
) => {
  return {
    ...param,
    bankCode: param.bankCode || '',
    bankName: bankName || param.bankName || '',
    branchCode: param.branchCode || '',
    branchName: branchName || param.branchName || '',
    accountNumber: param.accountNumber || '',
    depositForm: param.depositForm ?? null,
  };
};

//バリデーション
//銀行コードと店番号は片方のみ入力されることはないが念のためバリデーションを入れておく
export const depositAccountInfoValidation = Yup.object().shape({
  bankCode: yupNumberString({ length: 4, isRequired: true, errorWord: ErrorWord.BANK_INFO }),
  bankName: Yup.string().required(ErrorWord.BANK_INFO),
  branchCode: yupNumberString({ length: 3, isRequired: true, errorWord: ErrorWord.BANK_INFO }),
  branchName: Yup.string().required(ErrorWord.BANK_INFO),
  accountNumber: yupNumberString({
    length: 7,
    isRequired: true,
    errorWord:
      ErrorWord.INPUT_HALF_NUMBER +
      '。口座番号が7桁未満の場合は、口座番号の前に「0（ゼロ」「00」等を入力し、7桁になるようにしてください。',
  }),
  depositForm: Yup.number().required(ErrorWord.SELECT).typeError(ErrorWord.SELECT),
});

//Formikのサブミットメソッド
export const depositAccountInfoOnSubmit = <T>(param: T, add: (data: T) => void, cb?: () => void) => {
  return (values: DepositAccountType) => {
    add({
      ...param,
      bankCode: values.bankCode,
      bankName: values.bankName,
      branchCode: values.branchCode,
      branchName: values.branchName,
      accountNumber: values.accountNumber,
      depositForm: values.depositForm,
    });
    cb && cb();
  };
};
